import { render, staticRenderFns } from "./ConfigurationAnswerList.vue?vue&type=template&id=349e8e2a&"
import script from "./ConfigurationAnswerList.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationAnswerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports